import developConfig from "./develop.config";
import productionConfig from "./production.config";

export default (process.env.NODE_ENV === 'production') ? productionConfig : developConfig;